import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import OthersGroup from "../../../../groups/OthersGroup";

class MetricAvgDay2Arrival extends MetricBase {
    constructor() {
        super({
            field: "metric_avgday2arrival",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.avgDay2Arrival.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.avgDay2Arrival.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.avgDay2Arrival.tooltip"),
            group: new OthersGroup(),
        });
    }
}

export default MetricAvgDay2Arrival;
